// extracted by mini-css-extract-plugin
export default {"buyCourseBtn":"BuyCourseBtn_buyCourseBtn__BnUbJ"};